// libs
import { useEffect } from 'react';
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import addYears from 'date-fns/addYears';
import { useSession } from 'next-auth/react';
// App
import { useCountShopReservations, useGetShopReservationsEvents } from 'app-shared/lib/api/reservation';
import { countOrZero, getShopIdWhenAllowed } from './pending-counts.utils';
import { RESERVATIONS_TO_VALIDATE_STATUSES, RESERVATIONS_TO_WELCOME_STATUSES } from './pending-counts.constants';

const usePendingReservationsCount = (shopId: number | undefined, isAllowed: boolean): number => {
  const { data: session } = useSession();
  const today = new Date();
  const startOfToday = startOfDay(today);
  const allowedShopId = getShopIdWhenAllowed(shopId, isAllowed);
  const { data: reservationSavedEvent } = useGetShopReservationsEvents(allowedShopId, session);
  const { data: reservationsToValidateCount, mutate: refreshReservationsToValidateCount } = useCountShopReservations(
    allowedShopId,
    startOfToday,
    addYears(startOfToday, 1),
    RESERVATIONS_TO_VALIDATE_STATUSES
  );
  const {
    data: todayReservationsToWelcomeCount,
    mutate: refreshTodayReservationsToWelcomeCount,
  } = useCountShopReservations(allowedShopId, startOfToday, endOfDay(today), RESERVATIONS_TO_WELCOME_STATUSES);

  useEffect(() => {
    if (!reservationSavedEvent) return;

    refreshReservationsToValidateCount();
    refreshTodayReservationsToWelcomeCount();
  }, [reservationSavedEvent]);

  const pendingReservationsCount =
    countOrZero(reservationsToValidateCount) + countOrZero(todayReservationsToWelcomeCount);

  return pendingReservationsCount;
};

export default usePendingReservationsCount;
